var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',{attrs:{"lang":"yaml","theme":"cobalt","width":"100%","height":"600"},on:{"init":_vm.editorInit},model:{value:(_vm.yamlText),callback:function ($$v) {_vm.yamlText=$$v},expression:"yamlText"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }